/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S12_HeadingInputs */

const tr_kullanim_s12_heading = /** @type {(inputs: Kullanim_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Sözleşmenin Süresi ve Yenileme`)
};

const en_kullanim_s12_heading = /** @type {(inputs: Kullanim_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Term of the Agreement and Renewal`)
};

const de_kullanim_s12_heading = /** @type {(inputs: Kullanim_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Vertragslaufzeit und Verlängerung`)
};

const ru_kullanim_s12_heading = /** @type {(inputs: Kullanim_S12_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Срок Договора и продление`)
};

/**
* | output |
* | --- |
* | "12. Term of the Agreement and Renewal" |
*
* @param {Kullanim_S12_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s12_heading = /** @type {((inputs?: Kullanim_S12_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S12_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s12_heading(inputs)
	if (locale === "de") return de_kullanim_s12_heading(inputs)
	if (locale === "ru") return ru_kullanim_s12_heading(inputs)
	return tr_kullanim_s12_heading(inputs)
});